import {createActionThunk} from 'redux-thunk-actions';
import AT from '../actionTypes';
import * as API from '../../services/api.services';

export const hipaaGetList = createActionThunk(AT.HIPAA_GET_LIST, (patient_id) =>
  API.hipaaGetList(patient_id),
);
